import { render, staticRenderFns } from "./AddEditAppointmentTypePopup.vue?vue&type=template&id=04f966b4"
import script from "./AddEditAppointmentTypePopup.vue?vue&type=script&lang=ts"
export * from "./AddEditAppointmentTypePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports